<template>
  <details class="process-rail" :open="opened">
    <summary class="process-summary" @click.prevent="toggle">
      <span class="pulse" :class="{ on: active }" aria-hidden="true" />
      <span class="summary-title">{{ summaryTitle }}</span>
      <span class="summary-meta">{{ summaryMeta }}</span>
      <span class="chevron" :class="{ open: opened }" aria-hidden="true" />
    </summary>
    <ol class="process-list">
      <li
        v-for="(step, index) in steps"
        :key="index"
        class="process-item"
        :class="[step.kind, step.status]"
      >
        <span class="kind">{{ kindLabel(step.kind) }}</span>
        <div class="body">
          <p class="label">{{ step.label }}</p>
          <pre v-if="step.detail" class="detail">{{ formatDetail(step) }}</pre>
        </div>
        <span class="state" aria-hidden="true">{{ stateMark(step.status) }}</span>
      </li>
    </ol>
  </details>
</template>

<script>
export default {
  name: 'QueryProcessRail',
  props: {
    steps: { type: Array, default: () => [] },
    /** True while the real request is in flight */
    active: { type: Boolean, default: false },
    /** Force open while active; after finish keep last preference */
    title: { type: String, default: '' }
  },
  data() {
    return {
      userOpen: true
    }
  },
  computed: {
    opened() {
      if (this.active) return true
      return this.userOpen
    },
    summaryTitle() {
      if (this.title) return this.title
      return this.active ? '模型正在规划并调用工具…' : '本次检索过程'
    },
    summaryMeta() {
      const total = this.steps.length
      const done = this.steps.filter((step) => step.status === 'done').length
      if (!total) return ''
      if (this.active) return `${done}/${total}`
      return `${total} 步`
    }
  },
  watch: {
    active(value) {
      if (value) this.userOpen = true
    }
  },
  methods: {
    toggle() {
      if (this.active) return
      this.userOpen = !this.userOpen
    },
    kindLabel(kind) {
      if (kind === 'plan') return '规划'
      if (kind === 'tool') return '执行'
      if (kind === 'reason') return '推理'
      return '步骤'
    },
    stateMark(status) {
      if (status === 'done') return '✓'
      if (status === 'active') return '…'
      return '○'
    },
    formatDetail(step) {
      return String(step.detail || '')
    }
  }
}
</script>

<style scoped>
.process-rail {
  margin: 0 0 14px;
  background: #fff;
  border: 1px solid #e5e6eb;
  border-radius: 14px;
  overflow: hidden;
}
.process-summary {
  list-style: none;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 14px;
  cursor: pointer;
  user-select: none;
  color: #1d2129;
}
.process-summary::-webkit-details-marker { display: none; }
.pulse {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #c9cdd4;
  flex: 0 0 auto;
}
.pulse.on {
  background: #165dff;
  box-shadow: 0 0 0 0 rgba(22, 93, 255, 0.45);
  animation: pulse 1.2s ease-out infinite;
}
@keyframes pulse {
  0% { box-shadow: 0 0 0 0 rgba(22, 93, 255, 0.4); }
  70% { box-shadow: 0 0 0 8px rgba(22, 93, 255, 0); }
  100% { box-shadow: 0 0 0 0 rgba(22, 93, 255, 0); }
}
.summary-title {
  font-size: 14px;
  font-weight: 600;
}
.summary-meta {
  margin-left: auto;
  font-size: 12px;
  color: #86909c;
}
.chevron {
  width: 8px;
  height: 8px;
  border-right: 2px solid #86909c;
  border-bottom: 2px solid #86909c;
  transform: rotate(45deg);
  transition: transform 0.15s ease;
  margin-left: 4px;
}
.chevron.open {
  transform: rotate(225deg);
  margin-top: 4px;
}
.process-list {
  margin: 0;
  padding: 0 14px 12px;
  list-style: none;
  display: grid;
  gap: 8px;
  border-top: 1px solid #f2f3f5;
  padding-top: 10px;
}
.process-item {
  display: grid;
  grid-template-columns: 44px minmax(0, 1fr) 18px;
  gap: 10px;
  align-items: start;
  padding: 8px 10px;
  border-radius: 10px;
  background: #fafbfc;
  border: 1px solid transparent;
}
.process-item.active {
  background: #e8f3ff;
  border-color: #bedaff;
}
.process-item.done {
  opacity: 0.92;
}
.kind {
  font-size: 11px;
  font-weight: 600;
  color: #86909c;
  letter-spacing: 0.04em;
  padding-top: 2px;
}
.process-item.plan .kind { color: #0fc6c2; }
.process-item.reason .kind { color: #722ed1; }
.process-item.tool .kind { color: #165dff; }
.body { min-width: 0; }
.label {
  margin: 0;
  font-size: 13px;
  color: #1d2129;
  line-height: 1.45;
}
.detail {
  margin: 6px 0 0;
  font-size: 12px;
  line-height: 1.5;
  color: #86909c;
  white-space: pre-wrap;
  word-break: break-word;
}
.state {
  font-size: 12px;
  color: #86909c;
  text-align: right;
  padding-top: 2px;
}
.process-item.active .state { color: #165dff; }
.process-item.done .state { color: #00b42a; }
</style>
